export const APP_NAME = 'Rent Glow';
export const APP_DESCRIPTION = 'Închirieri Auto de Lux';
